<template>
  <div class="home" v-loading="loading">
    <!-- <swiper id="swiperBox" v-bind:options="swiperOption" ref="mySwiper"> -->
      <div style="position: relative;">
        <el-carousel height="calc(100vh - 60px)">
          <el-carousel-item v-for="item in topBanner" :key="item.id">
            <img v-if="isImg(item.img)" :src="item.img" alt="" style="width: 100%;height: calc(100vh - 60px);object-fit: cover;">
            <video v-else :src="item.img" style="width:100%;height:calc(100vh - 60px)" controls></video>
          </el-carousel-item>
        </el-carousel>
        <div class="swiper-slide slide-one" style="margin-top: 15%;">
          <div class="page animate__animated animate__bounceInDown">
            <h3 :style="{fontSize: '32px', fontWeight: bannerFontWeight}" class="">{{banner_company}}</h3>
            <div class="line_bottom animate__animated"></div>
            <p :style="{fontWeight: bannerFontWeight,marginTop: '40px',fontSize: '64px'}" class="text-desc">{{banner_slogan}}</p>
            <div style="transform: scale(0.5);margin-top: 30px;">
              <div class="mouse"></div>
              <p class="mousep">鼠标滚动</p>
            </div>
          </div>
          <!-- <p class="slogan">立人立己 达人达己</p> -->
        </div>
      </div>
      <div class="swiper-slide slide-two" :style="{backgroundImage: `url(${getUrl('home_two_1')})`}">
        <div class="page animate__animated" id="case">
          <h3 style="font-weight: 500;">经典案例</h3>
          <p style="font-size: 20px;">Successful Case</p>
        </div>
        <div class="case-box">
          <ul class="case-item">
            <li
              v-for="(item,index) in caseList"
              :key="index"
              v-lazy:background-image="item.coverImg"
            >
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.id }}"
              >
                <div class="case-item-hover">
                  <p class="hover-title animate__animated animate__fadeInDown">{{item.title}}</p>
                  <!-- <div class="bottom"></div> -->
                  <div class="more animate__animated animate__fadeIn">
                    <span>MORE</span>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="swiper-slide slide-three" :style="{backgroundImage: `url(${getUrl('home_three_1')})`}">
        <div class="page animate__animated" id="news">
          <h3 style="font-weight: 500;">最新资讯</h3>
          <p style="font-size: 20px;">Latest News</p>
        </div>
        <div class="news-content">
          <div class="news-content-item" v-for="(news,i) in newsList" :key="i">
            <div :style="'order: '+ (i%2==0 ? 1: 3)">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: news.id, type: 'news' }}"
              >
                <div class="item-img" v-lazy:background-image="news.coverImg"></div>
              </router-link>
            </div>
            <div style="order: 2">
              <el-divider>
                <i class="el-icon-apple"></i>
              </el-divider>
            </div>
            <div :class="['item-content', i%2==1 ? 'active': '']" :style="'order: '+ (i%2==0 ? 3: 1)">
              <h3 v-if="i%2 == 0">{{news.title}}</h3>
              <span v-else>{{news.occurenceTime}}</span>
              <!-- <p>{{news.Content}}</p> -->
              <span v-if="i%2 == 0">{{news.occurenceTime}}</span>
              <h3 v-else>{{news.title}}</h3>
            </div>
          </div>
        </div>
      </div>
    <!-- </swiper> -->
  </div>
</template>
 
<script>
// import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getArticleByCateId, getBannerList, getWebsiteConfigList } from '../api/index'
export default {
  name: "HelloWorld",
  // components: {
  //   swiper,
  //   swiperSlide
  // },
  data() {
    return {
      loading: true,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: false, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        }
      },
      bannerList: [
        // 'http://yucheng-website.aboutnetwork.cn/api/system/file/20240104/20240104160815.jpg',
        // 'http://yucheng-website.aboutnetwork.cn/api/system/file/20240103/20240103180007.jpg',
        // 'http://yucheng-website.aboutnetwork.cn/api/system/file/20240108/20240103171809(2).jpg'
      ],
      topBanner: [],
      banner_company: '',
      banner_slogan: ''
    };
  },
  created() {
    getBannerList().then((res) => {
      this.bannerList = res.data
      this.topBanner = res.data.filter(item => item.code.includes('home_one'))
    })
    getWebsiteConfigList().then(res => {
      this.banner_company = res.data.some(item => item.code === 'banner_name') ? res.data.find(item => item.code === 'banner_name').title : ''
      this.banner_slogan = res.data.some(item => item.code === 'banner_slogan') ? res.data.find(item => item.code === 'banner_slogan').title : ''
    })
    getArticleByCateId({
      cateId: '6',
    }).then(res => {
      this.caseList = res.data.slice(0,6)
    })

    getArticleByCateId({
      cateId: '9',
    }).then(res => {
      this.newsList = res.data.slice(0,3)
      this.loading = false
    })
  },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    bannerFontWeight() {
      // const agent = navigator.userAgent.toLowerCase()
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      return isMac ? '500' : 'normal'
    }
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollTop)
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`)
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.loading = false;
    //     })
    //   );
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollTop)
  },
  methods: {
    isImg(img) {
      return img.includes('.png') || img.includes('.jpg') || img.includes('.jpeg') || img.includes('.gif')
    },
    getUrl(code) {
      return this.bannerList.length ? this.bannerList.find(item => item.code === code).img : ''
    },
    scrollTop() {
      const list = ['case','news']
      list.forEach((item) => {
        const rect = document.getElementById(item).getBoundingClientRect()
        const notShow = rect.top >=
            (window.innerHeight || document.documentElement.clientHeight) ||
          rect.bottom <= 0
        if (!notShow) {
          document.getElementById(item).classList.add('animate__bounceInUp')
        }
      })
    }
  }
};
</script>
 
<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
.swiper-slide {
  width: 100%;
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-content: center;
  background-size: cover;
  height: 100vh;
  // height: calc(100vw / 1.77);
  overflow: hidden;

  .page {
    text-align: center;
    // height: 100px;
    overflow: hidden;
    // margin-top: 20px;
    .line_bottom {
      width: 55px;
      height: 7px;
      background: linear-gradient(90deg, #3364ff 0%, #7994ff 100%);
      border-radius: 4px;
      margin: 10px 0 16px 0;
      margin-left: 50%;
      transform: translateX(-50%);
    }
    .mouse {
      margin: 0 auto;
      background: #4e5559 linear-gradient(transparent,transparent 50%,#fff 0,#fff);
      position: relative;
      width: 52px;
      height: 88px;
      background-size: 100% 100%;
      border-radius: 100px;
      animation: colorSlide 5s linear infinite, nudgeMouse 5s ease-out infinite;
    }
    @keyframes colorSlide {
      0% {
          background-position: 0% 100%;
      }
      20% {
          background-position: 0% 0%;
      }
      21% {
          background-color: #4e5559;
      }
      29.99% {
          background-color: #ffffff;
          background-position: 0% 0%;
      }
      30% {
          background-color: #4e5559;
          background-position: 0% 100%;
      }
      50% {
          background-position: 0% 0%;
      }
      51% {
          background-color: #4e5559;
      }
      59.99% {
          background-color: #ffffff;
          background-position: 0% 0%;
      }
      60% {
          background-color: #4e5559;
          background-position: 0% 100%;
      }
      80% {
          background-position: 0% 0%;
      }
      81% {
          background-color: #4e5559;
      }
      89.99%,
        100% {
          background-color: #ffffff;
      }
    }
    @keyframes nudgeMouse {
      0% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
      }
      20% {
          -webkit-transform: translateY(8px);
          transform: translateY(8px);
      }
      30% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
      }
      50% {
          -webkit-transform: translateY(8px);
          transform: translateY(8px);
      }
      60% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
      }
      80% {
          -webkit-transform: translateY(8px);
          transform: translateY(8px);
      }
      90% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
      }
    }
    .mouse::before,
    .mouse::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
    .mouse::before {
      width: 46px;
      height: 82px;
      background-color: #222a30;
      border-radius: 100px;
    }
    .mouse::after {
      background-color: #ffffff;
      width: 10px;
      height: 10px;
      border-radius: 100%;
      -webkit-animation: trackBallSlide 5s linear infinite;
      animation: trackBallSlide 5s linear infinite;
    }
    @keyframes trackBallSlide {
      0% {
          opacity: 1;
          -webkit-transform: scale(1) translateY(-20px);
          transform: scale(1) translateY(-20px);
      }
      6% {
          opacity: 1;
          -webkit-transform: scale(0.9) translateY(5px);
          transform: scale(0.9) translateY(5px);
      }
      14% {
          opacity: 0;
          -webkit-transform: scale(0.4) translateY(40px);
          transform: scale(0.4) translateY(40px);
      }
      15%,
        19% {
          opacity: 0;
          -webkit-transform: scale(0.4) translateY(-20px);
          transform: scale(0.4) translateY(-20px);
      }
      28%,
        29.99% {
          opacity: 1;
          -webkit-transform: scale(1) translateY(-20px);
          transform: scale(1) translateY(-20px);
      }
      30% {
          opacity: 1;
          -webkit-transform: scale(1) translateY(-20px);
          transform: scale(1) translateY(-20px);
      }
      36% {
          opacity: 1;
          -webkit-transform: scale(0.9) translateY(5px);
          transform: scale(0.9) translateY(5px);
      }
      44% {
          opacity: 0;
          -webkit-transform: scale(0.4) translateY(40px);
          transform: scale(0.4) translateY(40px);
      }
      45%,
        49% {
          opacity: 0;
          -webkit-transform: scale(0.4) translateY(-20px);
          transform: scale(0.4) translateY(-20px);
      }
      58%,
        59.99% {
          opacity: 1;
          -webkit-transform: scale(1) translateY(-20px);
          transform: scale(1) translateY(-20px);
      }
      60% {
          opacity: 1;
          -webkit-transform: scale(1) translateY(-20px);
          transform: scale(1) translateY(-20px);
      }
      66% {
          opacity: 1;
          -webkit-transform: scale(0.9) translateY(5px);
          transform: scale(0.9) translateY(5px);
      }
      74% {
          opacity: 0;
          -webkit-transform: scale(0.4) translateY(40px);
          transform: scale(0.4) translateY(40px);
      }
      75%,
        79% {
          opacity: 0;
          -webkit-transform: scale(0.4) translateY(-20px);
          transform: scale(0.4) translateY(-20px);
      }
      88%,
        100% {
          opacity: 1;
          -webkit-transform: scale(1) translateY(-20px);
          transform: scale(1) translateY(-20px);
      }
    }
    p.mousep{
      margin-top: 40px;
      font-weight: 300;
      font-size: 28px;
      letter-spacing: 12px;
      text-indent: 12px;
      color: #ffffff;
      animation: colorText 5s ease-out infinite,nudgeText 5s ease-out infinite;
    }
    @keyframes colorText{
      21% {
          color: rgba(255, 255, 255, 0);
      }
      30% {
          color: #ffffff;
      }
      51% {
          color: rgba(255, 255, 255, 0);
      }
      60% {
          color: #ffffff;
      }
      81% {
          color: rgba(255, 255, 255, 0);
      }
      90% {
          color: #ffffff;
      }
    }
    @keyframes nudgeText {
      0% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
      }
      20% {
          -webkit-transform: translateY(2px);
          transform: translateY(2px);
      }
      30% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
      }
      50% {
          -webkit-transform: translateY(2px);
          transform: translateY(2px);
      }
      60% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
      }
      80% {
          -webkit-transform: translateY(2px);
          transform: translateY(2px);
      }
      90% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
      }
    }
    h3,
    p {
      font-size: 48px;
      font-weight: 400;
      color: #fff;
      letter-spacing: 2px;
    }
    h3 {
      font-size: 40px;
      letter-spacing: 4px;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}
//经典案例
.case-item {
  width: 1400px;
  // height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  // justify-content: flex-start;
  justify-content: space-between;
  li {
    width: 416px;
    height: 265px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        visibility: visible;
        display: block;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // opacity: 0;
  display: none;
  overflow: hidden;
  background-color: rgb(63, 86, 179, 0.8);

  .hover-title {
    // height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    font-weight: 400;
    margin-top: 80px;
    text-align: center;
    padding: 0 30px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 20px;
    border: 2px solid #fff;
    text-align: center;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
::v-deep {
  .el-carousel__arrow {
    display: none;
  }
}
.swiper-slide {

}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  // background: url(../assets/img/home_top.jpg) no-repeat center;
  // background-image: url('http://yucheng-website.aboutnetwork.cn/api/system/file/20240108/20240103171809(2).jpg');
  background-size: cover;
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  height: auto;
  // width: auto;
}
.slide-two {
  // background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
  justify-content: center;
}
.slide-three {
  // background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
  justify-content: center;
}
//最新资讯
.news-content {
  width: 1400px;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;

  &-item {
    width: 450px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 430px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
      overflow: hidden;
      transition: all .4s;
      &:hover {
        background-size: 120%;
      }
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: center;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
    .active {
      display: flex;
      flex-direction: column-reverse;
      // align-items: flex-end;
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}

// 手机版样式
@media screen and (max-width: 997px) {
  .text-desc {
    font-size: 40px !important;
  }
  .case-box {

    width: calc(100% - 20px);
    overflow-x: auto;
    .case-item {
      width: 1040px;
      li {
        flex-shrink: 0;
        width: 330px;
      }
    }
  }
  .news-content {
    width: calc(100% - 20px);
    overflow-x: auto;
    justify-content: start;
  }
}
</style>